export const WIDGET_ERROR_PREFIX = '[Credible© Widget - ERROR] \n'
export const WIDGET_INFO_PREFIX = '[Credible© Widget - INFO] \n'
export const SDK_INIT_ERROR_NAME = 'SDK_init_widget_error'
export const WIDGET_LOAD_TIME_INFO_NAME = 'widget_load_time_info'
export const CLIENT_SDK_GLOBAL_NAME = 'CredibleSDKClient'
